import { FixedSizeList as List } from "react-window";
import {
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
	CommandDialog,
} from "@lab/src/components/ui/command";

import { SetStateAction, useMemo, useState } from "react";
import { useCentralStore } from "@/dentlab/src/store/Central";
import {
	filterActiveClients,
	getClientDisplayName,
} from "@/lib/utils/client-utils";

export const ClientCommandDialog: React.FC<{
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	onClientSelect: (clientId: string) => void;
}> = ({ open, setOpen, onClientSelect }) => {
	const { clientsLookup } = useCentralStore((state) => ({
		clientsLookup: state.clientsLookup,
	}));

	const [searchTerm, setSearchTerm] = useState("");

	const filteredClients = useMemo(() => {
		const activeClients = filterActiveClients(Object.values(clientsLookup));
		if (!searchTerm) {
			return activeClients;
		}
		const lowerSearchTerm = searchTerm.toLowerCase();
		return activeClients.filter((client) => {
			const displayName = getClientDisplayName(client).toLowerCase();
			return displayName.includes(lowerSearchTerm);
		});
	}, [clientsLookup, searchTerm]);

	const handleDialogOpenChange = (open: boolean) => {
		setOpen(open);
		if (!open) {
			setSearchTerm("");
		}
	};

	return (
		<CommandDialog open={open} onOpenChange={handleDialogOpenChange}>
			<CommandInput
				noListSearch
				placeholder="Kunde suchen…"
				value={searchTerm}
				onValueChange={setSearchTerm}
			/>
			<CommandList className="h-96 max-h-96">
				<CommandGroup className="w-[500px]">
					<List
						height={324}
						itemCount={filteredClients.length}
						itemSize={50}
						width="100%"
					>
						{({ index, style }) => {
							const client = filteredClients[index];
							const clientId = client?.id;
							const name = getClientDisplayName(client);
							return (
								<CommandItem
									key={clientId}
									className="flex cursor-pointer w-full h-full flex-row gap-2 items-center"
									style={style}
									onSelect={() => {
										onClientSelect(clientId || "");
										setOpen(false);
									}}
								>
									<div className="text-lg">{name}</div>
									<div className="text-gray-500">
										{client.code}
									</div>
								</CommandItem>
							);
						}}
					</List>
				</CommandGroup>
			</CommandList>
		</CommandDialog>
	);
};
